<template>
  <div class="font-26 c-191F25 ff-regular">
    <div class="pb-60">
      <div class="lh-48 h-48 bg-FFFFFF pl-16 pr-16">
        <span class="ff-medium font-36 pr-5">已为您推荐考勤组设置</span
        ><span
          class="font-32 c-006AFE"
          @click="handlerPopups('attendanceGroup')"
          >(点击了解考勤组)</span
        >
      </div>

      <div
        class="bg-FFFFFF bt c-191F25-72"
        v-for="(item, index) in modelList"
        :key="index"
        @click="handlerSelectModel(item, index)"
      >
        <div
          class="mt-16 mb-8 m-0-16 font-34 c-191F25 fb fb-row fb-cross-center fb-main-between"
        >
          <span>{{ item.title }}</span>
          <i
            class="iconfont mr-8"
            :class="
              modelList.length === 1 || index !== selectIndex
                ? 'c-191F25-28'
                : 'c-006AFE'
            "
            >{{ selectIndex === index ? '&#xe66e;' : '&#xe66f;' }}</i
          >
        </div>
        <div class="font-28 p-0-16 pb-8 fb fb-row">
          <i class="iconfont c-191F25-28 mr-8">&#xe61b;</i>
          <span class="">{{ item.parted }}</span>
        </div>
        <div class="font-28 p-0-16 lh-24 mb-8 fb fb-row">
          <i class="iconfont c-191F25-28 mr-8">&#xe619;</i>
          <span>{{ item.time }}</span>
        </div>
        <div
          class="font-28 p-0-16 fb fb-row"
          :class="item.face ? 'pb-8' : 'pb-16'"
        >
          <i class="iconfont c-191F25-28 mr-8">&#xe61d;</i>
          <span>{{ item.device }}</span>
        </div>
        <div class="font-28 p-0-16 pb-16 fb fb-row" v-if="item.face">
          <i class="iconfont c-191F25-28 mr-8">&#xe61a;</i>
          <span>{{ item.face }}</span>
        </div>
      </div>
    </div>
    <new-attendance :show="showNew" @close="closeNew"> </new-attendance>
    <div class="footer fb fb-main-start fb-cross-center">
      <common-button
        type="primary-empty"
        class="mr-7"
        @click="handlerCreateAttendance"
        >创建新的考勤组</common-button
      >
      <common-button @click="handlerSubmit">使用模版配置</common-button>
    </div>
    <common-help-popup :show="showHelp" @close="closePopups" :link="link">
    </common-help-popup>
  </div>
</template>

<script>
import API from '../api'
import commonHelpPopup from './commonHelpPopup'
import newAttendance from './newAttendance'
import commonButton from './commonButton'
import { ATTENDANCE_MODEL_DATA } from '@/utils/attendanceModelConst'
export default {
  components: { commonHelpPopup, commonButton, newAttendance },
  props: {
    backLayer: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      modelList: [],
      showHelp: false,
      showNew: false,
      link: 'attendanceGroup',
      selectIndex: 0,
      postData: {
        timeSettingList: [],
        schoolPeriodType: 10
      },
      campusClassic: (this.$store.getters.currentCapmus || {}).classic ? 1 : 0
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    if (this.campusClassic === 0) {
      this.modelList.push(ATTENDANCE_MODEL_DATA[`periodType-10`])
      this.postData = {
        timeSettingList: this.modelList[0].timeSettingList,
        schoolPeriodType: this.modelList[0].id
      }
    } else {
      this.fetchGetAttendanceGroups()
    }
    this.handlerClearStoreCommit()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 打开弹窗
    handlerPopups(link) {
      this.showHelp = true
      this.link = link
    },
    // 关闭弹窗
    closePopups(show) {
      this.showHelp = show
    },
    // 关闭弹窗
    closeNew(show) {
      this.showNew = show
    },
    // 创建新的考勤组
    handlerCreateAttendance() {
      this.$router.push({
        path: '/attendance/group/save',
        query: {}
      })
    },
    // 使用模版配置
    handlerSubmit() {
      this.$router.push({
        path: '/attendance/group/save',
        query: {
          isModel: true,
          modelData: {
            timeSettingList: this.postData.timeSettingList,
            schoolPeriodType: this.postData.schoolPeriodType
          },
          backLayer: this.backLayer,
          attendanceGroupName: this.modelList[this.selectIndex].title
        }
      })
    },
    //  选择模版
    handlerSelectModel(item, index) {
      this.selectIndex = index
      this.postData = {
        timeSettingList: item.timeSettingList,
        schoolPeriodType: item.id
      }
    },
    handlerClearStoreCommit() {
      this.$store.commit('saveGroupName', null)
      this.$store.commit('saveGroupMember', null)
      this.$store.commit('saveGroupDepts', null)
      this.$store.commit('currentTagId', null)
      this.$store.commit('attendanceDays', null)
      this.$store.commit('saveEntranceDevice', ['deviceIds', null])
      this.$store.commit('saveEntranceDevice', ['attendanceDays', null])
      this.$store.commit('saveEntranceDevice', ['weekDeployDtoList', null])
      this.$store.commit('saveGroupDeviceIds', null)
      this.$store.commit('attendanceDate', [])
      this.$store.commit('saveGroupDtoList', null)
      this.$store.commit('saveGroupGuardian', null)
    },
    // 获取学段列表
    fetchGetPeriodList() {
      return new Promise((resolve, reject) => {
        let _postData = {
          tpCapmusId: window.localStorage.getItem('currentCapmusId')
        }
        API.dingGetPeriodList(_postData)
          .then(res => {
            let _periodList = res || []
            resolve(_periodList)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    fetchGetAttendanceGroups() {
      return new Promise((resolve, reject) => {
        API.attendanceAttendanceList({ attendanceGroupVersion: 1 })
          .then(res => {
            res.forEach((item, index) => {
              this.countNumber = this.countNumber + res[index].memberCount
            })
            this.groups = res || []
            if (this.groups.length === 0) {
              this.fetchGetPeriodList()
                .then(periodList => {
                  if (periodList && periodList.length) {
                    periodList.map(res => {
                      this.modelList.push(
                        ATTENDANCE_MODEL_DATA[`periodType${res.periodType}`]
                      )
                    })
                    this.postData = {
                      timeSettingList: this.modelList[0].timeSettingList,
                      schoolPeriodType: this.modelList[0].id
                    }
                  }
                })
                .catch(err => {
                  console.log(err)
                })
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-button {
  height: 24px;
  line-height: 24px;
  border-radius: 1000px;
  padding: 0 16px;
  border: 1px solid rgba(25, 31, 37, 0.6);
  color: rgba(25, 31, 37, 0.6);
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
}
</style>
